import React from 'react';
import clsx from 'clsx';
import { EllipsisVertical, GripVertical, SeparatorHorizontal } from 'lucide-react';
import { ROOT_CONTAINER } from '@repo/lib';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@dashboard/components/ui/dropdown-menu';
import { Button as ShadcnButton, buttonVariants } from '@dashboard/components/ui/button';
import MoveToMenu from './MoveToMenu';
import DisabledBadge from './DisabledBadge';
import { useFormLayout } from '../FormLayoutContext';

export default function DividerItem({
  divider,
  dragHandleProps,
  containerId = ROOT_CONTAINER,
  disabled,
}) {
  const { removeDivider, duplicateBlock, setBlockDisabled } = useFormLayout();
  const key = `divider:${divider.id}`;

  return (
    <div className="flex flex-row items-center gap-2 px-1" data-testid="divider-row">
      <div
        {...dragHandleProps}
        className={clsx(
          buttonVariants({ variant: 'ghost', size: 'icon' }),
          'cursor-grab active:cursor-grabbing',
        )}
      >
        <GripVertical className="size-4" />
      </div>
      <div className="flex min-w-0 flex-1 items-center gap-x-2 py-3">
        <SeparatorHorizontal className="size-4 shrink-0" aria-hidden="true" />
        <span className={clsx('text-sm font-medium', { 'opacity-60': divider.disabled })}>
          Divider
          {divider.disabled && <DisabledBadge />}
        </span>
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild disabled={disabled}>
          <ShadcnButton variant="ghost" size="icon" aria-label="More options" disabled={disabled}>
            <EllipsisVertical className="size-4" />
          </ShadcnButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <MoveToMenu itemKey={key} currentContainerId={containerId} />
          <DropdownMenuItem onSelect={() => duplicateBlock(key)}>Duplicate</DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setBlockDisabled(key, !divider.disabled)}>
            {divider.disabled ? 'Enable' : 'Disable'}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem variant="destructive" onSelect={() => removeDivider(divider.id)}>
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
